module.exports = __webpack_public_path__ + "static/media/gm.b7638709.svg";